import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import utils from '@utils';

class Final extends PureComponent {
	render() {
		const { JobEventStartDateTime, timeZoneId, approved } = this.props;

		return (
			<Choose>
				<When condition={approved}>
					<div className="flex flex-align-items-center padding-20 margin-top-30 margin-bottom-30">
						<div className="margin-right-30">
							<i className="rkf rkf-check-mark-o-solid font-size-40 color-green-base" />
						</div>
						<div>
							<div>
								{`Your job has been successfully scheduled for ${utils.parseUTCDateToTimeZone(JobEventStartDateTime, timeZoneId)
									.format('MMMM DD, YYYY')}.`}
							</div>
							<div>We will let you know of any changes to your job.</div>
						</div>
					</div>
				</When>
				<Otherwise>
					<div className="flex flex-align-items-center padding-20 margin-top-30 margin-bottom-30">
						<div className="margin-right-30">
							<i className="rkf rkf-cross-circle font-size-40 color-red-torch" />
						</div>
						<div>The job has been canceled</div>
					</div>
				</Otherwise>
			</Choose>
		);
	}
}

Final.propTypes = {
	JobEventStartDateTime : PropTypes.string,
	timeZoneId            : PropTypes.string.isRequired,
	approved              : PropTypes.bool,
};

Final.defaultProps = {
	JobEventStartDateTime : '',
	approved              : false,
};

export default Final;
